<template>
<v-footer id="home-footer" color="grey darken-4" dark min-height="72">
    <v-container>
        <v-row>
            <v-col cols="6" md="6">
                <a href="https://trello.com/b/41oydvVV/neo-booking" target="_blank" v-if="user && user.roles != 'User'">Trello Board</a>
                <!--
          <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
            <template v-for="(s, i) in social">
              <a
                :key="s"
                class="white--text pa-1 pa-md-0"
                href="#"
                v-text="s"
              />

              <v-responsive
                v-if="i < social.length - 1"
                :key="`divider-${s}`"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
          </div>
          -->
            </v-col>

            <v-col class="text-center text-md-right" cols="6" md="6">&copy; Jan Hjørdie, v. {{buildVersion}} <span v-if="user && user.roles == 'Admin'">{{baseFunctionUrl}}</span></v-col>
        </v-row>
    </v-container>
</v-footer>
</template>

<script>
import core from "./../../mixins/core";
import store from "./../../store";

export default {
    name: "HomeFooter",
    mixins: [core],

    data: () => ({
        social: ["Facebook", "Twitter", "Instagram", "Linkedin"],
        user: false
    }),
    methods: {
        updateUser() {
            this.user = store.getters.currentUser;
        },
    },
    created() {

        this.$store.subscribe((mutation, state) => {
            if (mutation.type === "setUser") {
                this.user = state.currentUser;
            }
        });
    },
};
</script>

<style lang="sass">
#home-footer a
  text-decoration: none
</style>